import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { getConfig } from 'src/global-config';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { AuthGuard } from 'src/auth/guard/auth-guard';
import { HRAuthGuard } from 'src/auth/guard/hr-guard';

import { usePathname } from '../hooks';
import { DashboardLayout } from './lazy-layouts';

// ----------------------------------------------------------------------

const GettingStartedPage = lazy(() => import('src/pages/getting-started'));

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  );
}

function dashboardLayout() {
  return (
    <DashboardLayout>
      <SuspenseOutlet />
    </DashboardLayout>
  );
}

// ----------------------------------------------------------------------

export function getGettingStartedRoutes(): RouteObject[] {
  const CONFIG = getConfig();

  return [
    {
      path: 'getting-started',
      element: CONFIG.auth.skip ? (
        dashboardLayout()
      ) : (
        <AuthGuard>
          <HRAuthGuard>{dashboardLayout()}</HRAuthGuard>
        </AuthGuard>
      ),
      children: [{ element: <GettingStartedPage />, index: true }],
    },
  ];
} 